<template>
	<div class=" qualityenterprise">
		<leftnav class="fl" :mkcode="curWebsite.type == 5 ? 'DB' : 'A'" itemcode="A-ZSDT"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage"> 
				<div class="heightVh95 whitebox container-flex-center">
							<freeUserTips :type="4" :bgtype="0" isShowPageTitle="地图搜索"></freeUserTips>
						</div> 
				</div>
				  
		</div>
	</div>
</template>

<script>
import { dataInJs } from "../../utils/city.js";
import BGMap from '../enterpriseInc/bgmap';
import EnterpriseDetail from '../enterpriseInc/enterprise-detail';
import CitySelector from '../enterpriseInc/city-selector';
import notify from '../../utils/notify';
import { totalqysl } from '@/utils/enterprise-tag.js'
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'enterprisemapsearch',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			// mapurl: '',
			time: '', curWebsite: this.$api.getWebsiteType(),
			title: "地图搜索",
			searchPlaceholder: '请输入企业名称',
			fenkd: {
				children: []
			},
			currentcity: {
				type: "city", id: 4301
			},
			notionCode: 0, tagCode: 0,
			chooseNotionlist: [0, 0, 0, 0, 0],
			searchtype: 0,
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			zcnotionlist1: [],
			zcnotionlist2: [],
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
			provinceID: 0,
			cityID: 0,
			countyID: 0,
			provincedata: dataInJs(),
			zhixiaCitydata: [11, 12, 50, 31],
			citydata: [],
			countydata: [],
			comSearchdata: [0, 'empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值
			totalqysl: [],
			searchtagdata: ['0'],
			//地图相关参数
			mapUtil: null,
			position: [],
			userInfo: {},
			showViewbar: false,
			list: [],
			viewList: [],
			mapPageList: [],
			mapPage: 1,
			mapPageSize: 10,
			mapTotal: 1,
			selectItem: {},
			selectPixel: null,
			showDetail: false,
			showCitySelect: false,
			areaId: 0,
			areaName: '',
			driving: null,
			isLoadNet: false,
			isSatellite: false,
			searchWord: '',
			showSearch: true,
			showSearchResult: false,
			searchList: [],
			searchTimerId: 0,
			//item.longitude,item.latitude
			cityLand: [],
			onloadbtn: true,
			// areadata: dataInJs(),
		}
	},
	components: {
		BGMap,
		EnterpriseDetail,
		CitySelector
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});

		// this.userdata = this.getuseriformation();
		// this.provinceID = this.userdata.province;
		// this.cityID = this.userdata.city;
		// this.totalqysl = totalqysl();
		// this.countyID=this.userdata.county;

	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// this.getThreeNotionList();
		// this.getCurrentTime();
		// this.getMapEnterpriseList();
		// this.mapUtil = this.$refs.bgmap.getMapUtil();
		// this.mapurl = this.$api.cyl.govementchart.mapserch() + '?token=' + this.userdata.token + "&date=" + this.time;
		// console.log(this.mapurl);
	},
	methods: {
		//调用三大概念列表
		getThreeNotionList() {
			//三大产业概念数据
			var ajaxurl = this.$api.tag.notion.list() + '?level=5',
				_this = this;
			this.getAxiosData(ajaxurl, this.userdata.token, function (res) {
				var dts = res.list;
				for (var i = 0; i < dts.length; i++) {
					var dts1 = dts[i].children;
					for (var d = 0; d < dts1.length; d++) {
						dts1[d].num = 0;
						for (var s = 0; s < dts1[d].children.length; s++) {
							dts1[d].children[s].num = 0;
						}
					}
				}
				_this.notionlist = res.list;

				// _this.bus.$emit('loading', false)111
			})
		},
		//调取地图企业列表，一次性5000条
		getMapEnterpriseList() {
			var ajaxurl = this.$api.cyl.map.enterpriseList() + '?page=1',
				_this = this;
			console.log(77777)
			this.getAxiosData(ajaxurl, this.userdata.token, function (res) {
				console.log('调取地图企业列表，一次性5000条', res)

				_this.bus.$emit('loading', false);
			})
		},
		//企业实力标签单选
		strengthTag(code) {
			this.tagCode = code;
			this.loadData();
			//调用列表函数
		},
		//概念单选 层级显示
		chooseNotion(step, type, data) {
			if (type == 'all') {
				this.notionCode = this.chooseNotionlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
					}
				}
				this.notionCode = data.value;
			}
			if (data.children != null) {
				if (step == 1) {
					this.notionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					// console.log(this.notionlist1)
					this.notionlist2 = []; this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children; this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children; this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			}
			// console.log(this.chooseNotionlist);
			this.loadData();
		},

		zhixiaCity(id) {
			let bool = false;
			// for(var i=0;i<this.zhixiaCitydata.length;i++){
			// 	if(id == this.zhixiaCitydata[i]){
			// 		bool=true;
			// 	}
			// }
			if (id == 11 || id == 31 || id == 12 || id == 50) {
				bool = true;
			}
			return bool;
		},
		ttsg() {
			this.notionlist1 = [];
			this.notionlist2 = [];
			this.notionlist3 = [];
			this.notionlist4 = [];
			this.notionlist5 = [];
			this.notionCode = 0; this.chooseNotionlist = [0, 0, 0, 0, 0, 0];
		},
		//省份城市选择 intype 初始化时只需要展开数据 不需要去搜索数据
		provincechoose(item, intype) {
			if (this.provinceid != item.areaId) {
				// this.ttsg(); 
				this.page = 1;
				let curcitydata = this.provincedata.filter(list => {
					return list.areaId == item.areaId;
				})
				item = intype == 'onload' ? curcitydata[0] : item;
				this.provinceID = item.areaId;
				this.cityLand = [item.longitude, item.latitude];//item.longitude,item.latitude  
				this.citydata = item.children ? item.children : [];
				let iszhixia = this.zhixiaCity(item.areaId);
				if (intype == "onload") {
					if (this.userdata.cityText != '') {
						this.choosecity({ areaId: this.userdata.city })
					}
				} else {
					if (iszhixia) {
						this.cityID = 0;
						this.countyID = 0;
						this.loadData();
					} else {
						let id1 = this.citydata[0].areaId;
						this.choosecity(this.citydata[0])
					}
				}

			}
		},
		choosecity(item) {
			//	console.log('choosecity',id); 
			this.ttsg();
			if (item == 'all') {
				this.cityID = 0; this.countyID = 0; this.countydata = [];
			} else {
				let curcitydata = this.citydata.filter(list => {
					return list.areaId == item.areaId;
				})
				item = curcitydata[0];
				if (this.cityID != item.areaId || this.cityID == this.userdata.city) {
					this.cityID = item.areaId; this.countyID = 0;
					this.countydata = item.children ? item.children : [];
					this.cityLand = [item.longitude, item.latitude];
				}
			}
			this.page = 1;
			this.loadData();
			this.areaName = item.areaName;
		},
		choosecounty(item) {
			//	console.log('choosecity',id);
			if (item == 'all') {
				this.countyID = 0;
			} else {
				this.countyID = item.areaId;
				this.cityLand = [item.longitude, item.latitude];
			}
			this.page = 1;
			this.loadData();
		},
		//招商地图map相关  页面筛选数据函数
		loadData(type) {
			this.bus.$emit('loading', true);
			var province = this.splicing('province', this.provinceID);
			var city = this.splicing('city', this.cityID);
			var county = this.splicing('county', this.countyID);
			var notion, tag, _this = this;
			if (this.onloadbtn) {
				notion = this.splicing('notion', this.userdata.notion);
				tag = this.splicing('tag', this.userdata.tag);
			} else {
				this.searchWord = ""; this.showSearchResult = false; this.searchList = [];
				notion = this.splicing('notion', this.notionCode);
				tag = this.splicing('tag', this.tagCode);
			}
			var ajaxurl = this.$api.cyl.map.enterpriseList() + '?page=1' + province + city + county + notion + tag;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(res => {
				_this.onloadbtn = false;
				var data = res.data;
				_this.list = data.list || [];
				console.log('筛选', ajaxurl, this.list);
				if (_this.list.length > 0) {
					_this.mapUtil.moveTo(_this.cityLand);
					_this.setViewList();
				}
				_this.bus.$emit('loading', false);
			});
		},
		onSelectCity(city) {
			if (city.id != this.areaId) {
				this.areaId = city.id;
				this.areaName = city.name;
				this.mapUtil.setCity(city.name, city);
				this.loadData(city.id);
			}
			this.showCitySelect = false;
		},
		onLocation({ position, area }) {
			console.log('index1', position, area);
			this.position = position; //旧版location 已暂停
			this.provincechoose({ areaId: this.userdata.province }, 'onload');
		},
		onZoomChange(zoom) {
			this.setViewList();
			// if(this.showDetail){
			//     this.selectedPixel = this.$refs.bgmap.refreshMap(this.selectItem);
			// }
		},
		onMapMove(center) {
			this.setViewList();
		},
		onCloseEnterpriseDetail() {
			this.showDetail = false;
			this.selectItem = {};
			this.selectPixel = {};
		},
		onSelectItem(data) {
			if (data.id != this.selectItem.id) {
				this.mapUtil.moveTo([data.lng, data.lat]);
				this.selectItem = data;
				this.showDetail = true;
				this.selectPixel = this.$refs.bgmap.showSelectItem(data);
			}
		},
		onNavigation(type) {
			console.log('navigation', type);
			this.driving = this.mapUtil.navigation({
				type,
				from: this.position,
				to: [this.selectItem.lng, this.selectItem.lat],
				city: this.areaName,
				panel: 'navigationPanel',
				callback: success => {
					this.$refs.detail.onNavigationComplete(success);
				}
			});
		},
		onNavigationClose() {
			if (this.driving) {
				this.driving.clear();
			}
		},
		toggleViewbar() {
			this.showViewbar = !this.showViewbar;
		},
		setViewList() {
			if (!this.list || this.length == 0 || this.showSearchResult) {
				return;
			}
			//var mapUtil = this.$refs.bgmap.getMapUtil();
			this.viewList = this.mapUtil.getViewList(this.list);
			this.$refs.bgmap.setData(this.viewList);
			this.changePage(1);
			this.mapTotal = this.viewList.length;
		},
		setSearchList() {
			this.$refs.bgmap.setSearchData(this.searchList);
		},
		setUserPosition() {
			this.mapUtil.moveTo(this.position);
		},
		changePage(page) {
			this.mapPage = page;
			var start = (page - 1) * this.mapPageSize;
			var end = start + this.mapPageSize;
			this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
			//console.log(this.pageList);
		},
		toggleLoadNet() {
			this.isLoadNet = !this.isLoadNet;
			if (this.isLoadNet) {
				this.mapUtil.addLoadNet();
			} else {
				this.mapUtil.removeLoadNet();
			}
		},
		toggleSetallite() {
			this.isSatellite = !this.isSatellite;
			if (this.isSatellite) {
				this.mapUtil.addSatellite();
			} else {
				this.mapUtil.removeSatellite();
			}
		},
		enterSearchIcon() {
			//console.log('enter');
			this.showSearch = true;
			setTimeout(() => {
				this.$refs.elSearch.focus();
			}, 500);
		},
		leaveSearchIcon() {
			//console.log('leave');
			this.showSearch = this.showSearchResult || false;
		},
		searchEnterprise(kw) {
			clearTimeout(this.searchTimerId);
			this.showSearchResult = this.searchWord != '';
			if (this.showSearchResult) {
				// this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
				this.bus.$emit('loading', true);
				var ajaxurl = this.$api.cyl.map.enterpriseList() + '?page=1&province=0&city=0&kw=' + this.searchWord,
					_this = this;
				this.getAxiosData(ajaxurl, this.userdata.token, function (res) {

					_this.searchList = res.list;
					_this.bus.$emit('loading', false);
				})


			} else {
				this.searchList = [];
			}
			this.searchTimerId = setTimeout(_ => {
				this.setSearchList();
			}, 1000);
		},
		formatSearchTitle(title) {
			return title.replace(this.searchWord, '<span class="redfont">' + this.searchWord + '</span>');
		},
		closeSearchBar() {
			this.showSearch = false;
			this.showSearchResult = false;
			this.searchWord = '';
			this.searchList = [];
			this.setViewList();
		},
		//地图相关结束
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.ajaxsearchcompany(1, 'srot', 'search');
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		getCurrentTime() {
			//获取当前时间
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			// 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss; 
			this.time = yy + '-' + mm + '-' + dd + ' ';
		},
	},
}
</script>

<style>
/* @import "../../../css/index.css"; */



/* 	.mapserch_mapbox{
		width: 100%;
		height: 40%;
		border: 1px solid red;
	} */
</style>
<style lang="scss" scoped>
body .el-card__header {
	padding: 13px 20px;
}

body .fade-enter-active {
	transition: width 2s;
}

body .word {
	color: #c00;
	font-weight: bold;
}

.sider-left {
	position: absolute;
	left: 20px;
	top: 20px;
	font-size: 14px;
	text-align: left;
	width: 380px;
	color: #000;
}

.area-bar {
	padding: 10px;
	position: relative;

	.count {
		margin: 0 10px;
	}

	.search-icon {
		float: right;
		margin-top: 7px;
		margin-right: 6px;
		font-size: 18px;

		&:hover {
			color: #39f;
		}
	}

	.el-icon-close {
		font-size: 18px;
	}

	.el-input__icon.el-icon-search {
		width: 18px;
		color: #5E83CC;
	}

	.search-bar {
		position: absolute;
		left: 0;
		top: 0;
		width: 98%;
		height: 100%;

		//display:none;
		.search-text {
			margin: 5px 4px;
			width: 300px;
		}

		.search-btn {
			width: 60px;
			color: #5E83CC;

		}

	}
}

.num,
.kw {
	color: rgb(16, 111, 189);
	font-weight: bold;
	margin: 0 8px;
}

.tool-bar {
	position: absolute;
	top: 20px;
	right: 20px;
	text-align: left;

	.btn-me {
		color: #c00;
		margin-right: 20px;
		padding: 3px;
		font-size: 22px;

		i {
			font-size: 24px;
		}

		&:hover {
			background: #e4f1ff;
			color: #f00;
		}
	}
}
</style>
<style scoped lang="scss">
#testmap {
	position: relative;
	width: 95%;
	margin: 0 auto 20px;
	// width: 100%;position: relative;
	overflow-y: hidden;
	overflow: hidden;
	height: 93.6vh;
}

.kw {
	color: #c00;
}

.el-icon-arrow-up {
	transition-duration: 0.2s;
}

.arrow-active {
	transform: rotate(180deg);
	transition-duration: 0.2s;
}

.view-bar {
	margin-top: 12px;
	position: relative;

	.box-card {
		.header {
			padding: 15px 20px;
		}

		.cont {
			padding: 5px 0;
			border-top: 1px solid #eee;
			height: 600px;
			overflow-y: scroll;

			.item {
				cursor: default;
				padding: 0 20px;
			}

			.active {
				background: #eee;

				.title {
					color: #f50;
				}
			}
		}

		.title {
			font-size: 16px;
			padding: 10px 0;
			font-weight: bold;
			color: rgba(9, 22, 49, 0.842);
		}

		.addr {
			font-size: 12px;
			color: #555;
			border-bottom: 1px solid #eee;
			padding: 5px 0 10px;
		}
	}

	.pagination {
		padding: 10px 0;
	}
}</style>
